<div class="form-group">
    <label class="input-label">Key:</label>
    <input type="text"
           disabled="true"
           name="key"
           [(ngModel)]="fieldOptions.key"
           class="form-control">
</div>